import SettingsUsersTableRow from "../SettingsUsersTableRow/SettingsUsersTableRow"
import "./SettingsUsersTable.scss"
import { ApiUser } from "~/types"

type SettingsUsersTableProps = {
  users: ApiUser[]
}

function SettingsUsersTable({ users = [] }: SettingsUsersTableProps) {
  const userRows = users.map((user, index) => {
    return <SettingsUsersTableRow index={index} apiUser={user} key={user.id} />
  })

  return (
    <table className="SettingsUsersTable">
      <thead>
        <tr>
          <th>Name</th>
          <th>Role</th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>{userRows}</tbody>
    </table>
  )
}

export default SettingsUsersTable
